const homeStats = () => {
  const pathOne = document.querySelector(".stats-path-one");
  const pathTwo = document.querySelector(".stats-path-two");
  const pathThree = document.querySelector(".stats-path-three");
  const pathFour = document.querySelector(".stats-path-four");
};

export default homeStats;
